import {createApi} from './_factory'
import type {AgentNs} from '@shared/types'

const api = createApi('agent/test')

export const AgentTestApi = {
  ping: () =>
    api.get<{ status: string; service: string }>('ping'),

  startRun: (data: AgentNs.TestRunRequest) =>
    api.post<AgentNs.TestRunRequest, AgentNs.TestRunStartResponse>('run', data),

  getRun: (runId: string) =>
    api.get<AgentNs.TestRunReport>(`runs/${runId}`),

  listRuns: (limit = 10) =>
    api.get<AgentNs.TestRunReport[]>(`runs?limit=${limit}`),

  listScenarios: () =>
    api.get<AgentNs.TestScenarioInfo[]>('scenarios'),

  reloadScenarios: () =>
    api.post<void, { loaded: number }>('scenarios/reload'),
}
